const handleClientHeader = () => {
  const body = document.querySelector('body');
  const injectedHeader = document.getElementById('injected-header');
  const mobileNav = document.querySelector('.nav-mobile');
  const hubHeader = document.getElementById('top-header');
  const largeHeader = document.querySelector('.large-header');
  const hubNav = document.querySelector('.top-nav');
  const mobileNavTrigger = document.querySelector('.nav-mobile__toggle');
  const mobileNavSubTriggers = [...document.querySelectorAll('.js-expandable-nav-group-toggle')];
  const socialMediaBar = require(`../includes/social-bar.html`);

  function handleScroll() {
    const scrollTop = window.scrollY;
    var followAt = hubHeader.offsetTop + hubHeader.clientHeight - injectedHeader.clientHeight;

    function isSticky() {
      return scrollTop >= followAt;
    }

    isSticky() ? hubNav.classList.add('is-sticky') : hubNav.classList.remove('is-sticky');
  }

  function handleMainToggle() {
    mobileNav.classList.toggle('is-expanded');
  }

  function handleSubToggle(evt) {
    evt.preventDefault();
    const targetParent = this.parentElement;
    targetParent.classList.toggle('is-expanded');
  }
  
  function animatedHubHeader() {
    const html = `
    <video 
    class="video-background" 
    no-controls autoplay loop muted playsinline
    src="http://get.chorus.ai/rs/792-MGP-091/images/Chorus_Resources-Header-Animation-11-04-19.mp4">
    </video>
    `;
    const videoContainer = document.createElement("div");

    videoContainer.classList.add('video-container');
    videoContainer.innerHTML = html;
    largeHeader.insertAdjacentElement('beforeend', videoContainer);
  }


  function changeSearchPlaceholder() {
    const searchInput = document.getElementsByName('q');
    searchInput[0].placeholder = 'Search Resources';
  }

  function bindEvents() {
    if (body.classList.contains('hub-page') || body.classList.contains('uf-stream-template-banner-marketing') || body.classList.contains('single-page') || body.classList.contains('listing-page')) {
      window.addEventListener('scroll', handleScroll);
    }

    mobileNavTrigger.addEventListener('click', handleMainToggle);

    mobileNavSubTriggers.forEach((sub) => sub.addEventListener('click', handleSubToggle));

    animatedHubHeader();
    changeSearchPlaceholder();
  }


  return bindEvents();
};

module.exports = handleClientHeader;


// WEBPACK FOOTER //
// ./modules/handleClientHeader.js